
	import {
		Component,
		Vue,
		Inject,
		Prop,
		Watch,
	} from 'vue-property-decorator';
	import Util from '@/lib/util';
	import wx from 'weixin-js-sdk';
	import AbpBase from '@/lib/abpbase';
	import Viewer from 'v-viewer'
	import 'viewerjs/dist/viewer.css'
	@Component({
		components: {}
	})
	export default class NewsDetail extends AbpBase {
		userAgent: string = "";
		news: Object = new Object() as any;
		newid: number = 0;
		pageSize: number = 10;
		pageIndex: number = 1;
		userid: number = 0;
		commentBox: boolean = false;
		commentList: Array < Object >= new Array < Object > ();
		commentContent: string = "";
		loadmore: boolean = true;
		optertionInfo: Object = {
			likeId: 0,
			isLike: false,
			followId: 0,
			isFollow: false
		};
		userInfo: Object = new Object();
		anonymous: boolean = false;
		imgBox: boolean = false;
		currentImgs: Array < Object >= new Array < Object > ();
		currentImgUrl: string = '';
		screenWidth: number = 0;


  


		showShare: boolean = false;
		shownews: number = 0; // 0加载中 1 可见 2 不可见
		msg: string = '';
		isPreview: boolean = false;
		newsReadCount: number = 0;
		handleReachBottom() {
			var that = this;
			if (that.loadmore) {
				that.pageIndex++;
				that.getNewsCommentList();
			}
		}
		hideCommentBox() {
			this.commentContent = "";
			this.commentBox = false;
		}
		goFullText() {
			if ((this.news as any).fullTextUrl.indexOf('pages/') < 0) {
				location.href = ((this.news as any).fullTextUrl);
			}
		}

		showCommentBox() {
			this.commentContent = "";
			this.commentBox = true;
		}
		share() {
			this.showShare = true;

		}
		isIos() {
			var u = navigator.userAgent.toLowerCase();
			this.userAgent = u;
			if (u.indexOf("iphone") > -1 || u.indexOf("ios") > -1 || u.indexOf("mac") > -1) {
				return true;
			}
			return false;
		}
		shareToWeixin(shareWeixinType) {
			var that = this;
			var news = (this.news as any);
			var title = news.title;
			var link = location.protocol + "//" + location.host + "/#/newsDetail?newid=" + news.id;
			var content = news.subTitle;
			var coverImg = news.coverImg;
			if (content == '') {
				content = title;
				title = '';
			}
			if (that.isIos()) {
				that.$store.dispatch({
					type: 'app/refreshOSSPresignedUri',
					data: {
						url: coverImg,
						process: 'image/resize,m_fixed,w_30,h_30'
					}
				}).then(res => {
					coverImg = res;
					that.gisShareToWeixin(title, content, link, coverImg, shareWeixinType);
				});
			} else {
				that.gisShareToWeixin(title, content, link, coverImg, shareWeixinType);
			}

		}
		gisShareToWeixin(title, content, link, coverImg, shareWeixinType) {
			var that = this;
			// shareWeixinType: string = "WXSceneSession" // WXSceneTimeline
			(window as any).gis.shareToWeixin({
				type: 'web',
				title: title,
				content: content,
				href: link,
				thumbs: [coverImg],
				extra: {
					scene: shareWeixinType
				},
				// pictures:[news.coverImg],
				success: function() {
					that.showShare = false;
					that.createNewsOperation(3);
				},
				fail: function() {
					that.showShare = false;
				}
			})
		}
		createNewsOperation(type) {
			var that = this;
			var operatrquest = {
				newsId: that.newid,
				relationType: type
			};
			this.$store.dispatch({
				type: 'app/writeNewsOperation',
				data: operatrquest
			}).then((res) => {
				if (type == 1) {
					(that.optertionInfo as any).likeId = res;
					(that.optertionInfo as any).isLike = true;
				} else if (type == 2) {
					(that.optertionInfo as any).followId = res;
					(that.optertionInfo as any).isFollow = true;
				}
			})
		}
		cancelNewsOperation(type) {
			var that = this;
			var id = 0;
			if (type == 1) {
				id = (that.optertionInfo as any).likeId;
			} else {
				id = (that.optertionInfo as any).followId;
			}
			this.$store.dispatch({
				type: 'app/cancelNewsOperation',
				data: {
					id: id
				}
			}).then((res) => {
				if (type == 1) {
					(that.optertionInfo as any).likeId = 0;
					(that.optertionInfo as any).isLike = false;
				} else if (type == 2) {
					(that.optertionInfo as any).followId = 0;
					(that.optertionInfo as any).isFollow = false;
				}
			})
		}
		createCommentOperation(comment) {
			var that = this;
			var operatrquest = {
				newsId: that.newid,
				relationType: 4,
				commentId: comment.id
			};
			this.$store.dispatch({
				type: 'app/writeNewsOperation',
				data: operatrquest
			}).then((res) => {
				comment.commentLikeCount = comment.commentLikeCount + 1;
				comment.userLikeId = res;
			})
		}
		cancelCommentOperation(comment) {
			var that = this;
			this.$store.dispatch({
				type: 'app/cancelNewsOperation',
				data: {
					id: comment.userLikeId
				}
			}).then((res) => {
				comment.commentLikeCount = comment.commentLikeCount - 1;
				comment.userLikeId = null;
			})
		}

		saveComment() {
			var that = this;
			if (that.userid == 0) {
				that.$Message.warning(this.L('请先登录'));
				return;
			}
			if (that.commentContent.length == 0) {
				that.$Message.warning(this.L('请输入评论的内容'));
				return;
			}
			var requestComment = new Object() as any;
			requestComment.newsId = that.newid;
			requestComment.comment = that.commentContent;
			requestComment.status = 0;
			requestComment.userId = that.userid;
			requestComment.anonymous = that.anonymous;
			this.$Message.loading({
				content: '',
				duration: 0
			});
			this.$store.dispatch({
				type: 'app/createComment',
				data: requestComment
			}).then((res) => {
				that.$Message.destroy();
				that.$Message.success(this.L('发布成功'));
				(res as any).datetime = Util.formatDateStr((res as any).creationTime);
				that.commentList.push(res);
				that.commentBox = false;
				that.commentContent = "";
				that.anonymous = false;
			})
		}
		getNewsCommentList() {
			var that = this;
			var request = new Object() as any;
			request.maxResultCount = this.pageSize;
			request.skipCount = (this.pageIndex - 1) * this.pageSize;
			request.newsId = that.newid;
			request.isApp = true;
			request.selectAll = true;
			this.$store.dispatch({
				type: 'app/getNewsCommentList',
				data: request
			}).then((res) => {
				var result = res.items as Array < Object > ;
				if (result.length < that.pageSize) {
					that.loadmore = false;
				}
				for (var i = 0; i < result.length; i++) {
					(result[i] as any).datetime = Util.formatDateStr((result[i] as any).creationTime);

					that.commentList.push(result[i]);
				}

				//that.commentList = res as Array < Object > ;
				//(that.news as any).time = Util.formatDate(new Date((that.news as any).creationTime), 'yyyy-MM-dd hh:mm:ss');
			})
		}
		getNewsOperationInfo() {
			var that = this;
			var that = this;
			var requestInfo = new Object() as any;
			requestInfo.newsId = that.newid;
			this.$store.dispatch({
				type: 'app/getNewsOperationInfo',
				data: requestInfo
			}).then((res) => {
				that.optertionInfo = res as Object;
			})
		}
		getNewsByID() {
			var that = this;
			this.$store.dispatch({
				type: 'app/getNewsById',
				id: this.newid
			}).then((res) => {

				that.news = res as any;

				if (that.userid == 0 && !that.isPreview) {
					if ((that.news as any).externalView != null && (that.news as any).externalView) {
						that.shownews = 1;
					} else {
						that.shownews = 2;
					}
				} else {
					that.shownews = 1;
					var date = (that.news as any).publishTime;
					if (date == null) {
						date = (that.news as any).creationTime;
					}
					(that.news as any).time = Util.formatDate(new Date(date), 'yyyy-MM-dd hh:mm:ss');

				}
				that.weixinShare();
			})
		}
		getNewsReadCount() {
			var that = this;
			this.$store.dispatch({
				type: 'app/getNewsReadCount',
				id: this.newid
			}).then((res) => {
				that.newsReadCount = res;
			})
		}
		writeNewsReadLog() {
			var that = this;
			this.$store.dispatch({
				type: 'app/writeNewsReadLog',
				data: {
					id: that.newid
				}
			}).then((res) => {

			})
		}

		getLoginUser() {
			var that = this;
			this.$store.dispatch({
				type: 'app/getLoginUser',
				data: {}
			}).then(res => {
				that.userInfo = res;
			})
		}
		isWeiXin() {
			var ua = navigator.userAgent.toLowerCase() as any;
			this.userAgent = ua;
			if (ua.match(/MicroMessenger/i) == 'micromessenger') {
				return true; // 是微信端
			} else {
				return false;
			}
		}
		weixinShare() {
			var that = this;
			if (this.isWeiXin()) {
				var news = that.news as any;
				var url = location.href.split('#')[0];
				that.msg = that.msg + 'is weixin';
				this.$store.dispatch({
					type: 'app/getWeixinJSSDKConfig',
					data: {
						url: url
					}
				}).then(res => {
					var config = res;
					wx.config({
						debug: false,
						appId: config.appId, // 必填，公众号的唯一标识
						timestamp: config.timestamp, // 必填，生成签名的时间戳
						nonceStr: config.nonceStr, // 必填，生成签名的随机串
						signature: config.signature, // 必填，签名
						jsApiList: ['checkJsApi',
							'onMenuShareTimeline',
							'onMenuShareAppMessage',
						] // 必填，需要使用的JS接口列表
					});
					that.msg = that.msg + ' configed';
					wx.ready(function() { //需在用户可能点击分享按钮前就先调用
						that.msg = that.msg + ' ready';
						wx.updateAppMessageShareData({
							title: news.title, // 分享标题
							desc: news.subTitle, // 分享描述
							link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: news.coverImg, // 分享图标
							success: function() {
								// 设置成功

							}
						})
						wx.onMenuShareAppMessage({
							title: news.title, // 分享标题
							desc: news.subTitle, // 分享描述
							link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: news.coverImg, // 分享图标
							type: 'link', // 分享类型,music、video或link，不填默认为link
							dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
							success: function() {
								// 用户点击了分享后执行的回调函数
							},
							cancel:function(){
								
							},
						});
						wx.onMenuShareTimeline({
							title: news.title, // 分享标题
							link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: news.coverImg, // 分享图标
							success: function() {
								// 用户点击了分享后执行的回调函数
							},
							cancel:function(){
								
							},
						});
						wx.updateTimelineShareData({
							title: news.title, // 分享标题
							link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: news.coverImg, // 分享图标
							success: function() {
								// 设置成功
							}
						})
					});

				})
			}

		}
		cancelImgBox() {
			this.imgBox = false;
		}

		@Watch('$route')
		routechange(to: any, from: any) {
			if (to.query.newid != from.query.newid) {
				location.reload();
			}
		}
		async created() {
			var that = this;
			that.screenWidth = document.body.clientWidth
		 
 

			if (!Util.abp.session.userId) {
				var domain = this.$route.query.domain as any;
				if (domain != undefined && domain != null && domain != '') {
					await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDSDOMAIN",
							"ProviderAccessCode": domain,
							ProviderKey: "",
							Property: ""
						},
					})
					location.reload();
				}
				var userId = this.$route.query.userid as any;
				if (userId != undefined && userId != null && userId != '') {
					await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDSID",
							"ProviderAccessCode": userId,
							ProviderKey: userId,
							Property: ""
						},
					})
					location.reload();
				}
			}

	 

			if (this.$route.query.newid && (this.$route.query.newid as any) > 0) {
				this.newid = this.$route.query.newid as any;

				if (Util.abp.session.userId) {
					this.userid = Util.abp.session.userId;
					this.getLoginUser();
					this.getNewsOperationInfo();
					this.writeNewsReadLog();
				}
				if (this.$route.query.preview && (this.$route.query.preview as any) > 0) {
					this.isPreview = true;
				}
				this.getNewsByID();
				this.getNewsReadCount();
				this.commentList = [];
				this.getNewsCommentList();
			}


		}
		mounted() {
			var that = this;
			setTimeout(function() {

				var u = navigator.userAgent.toLowerCase();

				//统一使用组件方式查看图片可以缩放
				if (1 == 1 || u.indexOf('iphone os 13_4') > -1 || u.indexOf('iphone os 14') > -1 || u.indexOf(
						'ipad') > -1 || u.indexOf('ipod') > -1 || that.screenWidth >= 768) {
					let imgs = document.getElementsByClassName('newscot')[0].getElementsByTagName('img');
					for (var i = 0; i < imgs.length; i++) {
						var img = imgs[i] as any;
						img.onclick = function(e) {
							// that.currentImgUrl = e.currentTarget.src;
							// that.currentImgs = [];
							// that.currentImgs.push(that.currentImgUrl);
							// that.imgBox = true;
							// that.$forceUpdate();
							//(window as any).gis.previewImage([e.currentTarget.src]);
							that.currentImgUrl = e.currentTarget.src;
							that.currentImgs = [];
							that.currentImgs.push(that.currentImgUrl);
							//that.imgBox = true;
							const ViewerDom = document.getElementById('viewer');
							((ViewerDom as any).viewer as any).options.title = false;
							((ViewerDom as any).viewer as any).options.navbar = false;
							((ViewerDom as any).viewer as any).options.toolbar = false;
							((ViewerDom as any).viewer as any).images = that.currentImgs;
							setTimeout(function() {
								var contain = document.getElementsByClassName('descimgBox')[0]
									.getElementsByTagName('img');;
								if (contain != null && contain.length > 0) {
									contain[0].click();
								}
							}, 300)
						}
						// img.ontouchend = function(e) {
						// 	(window as any).gis.previewImage([e.currentTarget.src]);
						// }
					}
				} else {
					let imgs = document.getElementsByClassName('newscot')[0].getElementsByTagName('img');

					for (var i = 0; i < imgs.length; i++) {
						var img = imgs[i] as any;
						img.onclick = function(e) {
							var img = imgs[i] as any;
							img.onclick = function(e) {
								(window as any).gis.previewImage([e.currentTarget.src]);
							}
						}

					}
				}


				let mps = document.getElementsByTagName('mp-miniprogram');
				for (var i = 0; i < mps.length; i++) {
					var mp = mps[i] as any;
					var miniprogramAppid = mp.dataset.miniprogramAppid;
					var imageUrl = mp.dataset.miniprogramImageurl
					var miniprogramPath = mp.dataset.miniprogramPath;
					var miniprogramTitle = mp.dataset.miniprogramTitle;
					var miniprogramType = mp.dataset.miniprogramType;
					var dom =
						'<span class="weapp_display_element js_weapp_display_element">' +
						'<span class="weapp_card app_context pages_reset appmsg_card_context appmsg_card_active">' +
						'<span class="weapp_card_bd" style="border: 1px solid #ddd;border-radius: 3px;padding: 10px;display: block;">' +
						'<span class="weapp_card_profile flex_context" style="display:block;text-align: left;">' +
						'<span class="radius_avatar weapp_card_avatar" style="display: inline-block;width: 30px;height:30px;border-radious:50%;vertical-align: middle;overflow: hidden;margin-right:10px;">' +
						'<img  src="' + imageUrl + '" style="display:block;width:100%;height:100%;">' +
						'</span>' +
						'<span class="flex_bd">' +
						'<span class="weapp_card_nickname_wrp">' +
						'<span class="guarantee_icon">交易担保</span>' +
						'<span class="weapp_card_nickname">小延商城</span>' +
						'</span>' +
						'</span>' +
						'</span>' +
						'<span class="weapp_card_info" style="display:block;">' +
						'<span class="weapp_card_title" style="display:block;text-align: left;font-size:15px;color:#333;margin:5px 0;">' +
						miniprogramTitle + '</span>' +
						'<span class="weapp_card_thumb_wrp" style="display:block;width:100%;"></span>' +
						'<img mode="widthFix" src="' + imageUrl + '" style="display:block;width:100%;">' +
						'</span>' +
						'</span>' +
						'<span class="weapp_card_ft">' +
						'<span class="weapp_card_logo" style="margin:10px 0;color:#666;">小程序</span>' +
						'</span>' +
						'</span>' +
						'</span>';
					var node = document.createElement("div");
					node.innerHTML = dom;
					mp.parentNode.appendChild(node);
				}
			}, 2000)
		}
	};
